import { X } from "lucide-react";
import { motion } from "framer-motion";
import { useAura, fmtClock } from "./useAura";
import AuraRadar from "./AuraRadar";
import type { EventRow } from "../../types/api";

export default function AuraHUD({ onClose, live }: { onClose: () => void; live: EventRow[] }) {
  const m = useAura();
  const latest = live[0];
  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      className="glass fixed bottom-4 right-4 z-30 w-64 p-3"
    >
      <div className="mb-1 flex items-center justify-between">
        <span className="section-tag">IN-CAB AURA HUD</span>
        <button onClick={onClose} className="text-slatey hover:text-ink">
          <X size={15} />
        </button>
      </div>
      <div className="flex justify-center">
        <AuraRadar m={m} size={150} />
      </div>
      <div className="mt-2 grid grid-cols-3 gap-1 text-center text-[10px]">
        <Metric label="PERCLOS" value={`${m.perclos}%`} />
        <Metric label="YAW" value={`${m.yaw}°`} />
        <Metric label="PULSE" value={`${m.pulse}`} />
      </div>
      <div className="mono mt-2 text-center text-[10px] text-aurora-teal">
        CLEAN SHIFT {fmtClock(m.cleanShiftSec)}
      </div>
      {latest && (
        <div className="mt-2 rounded-md border border-white/5 bg-white/5 p-1.5 text-[10px]">
          <span className="text-slatey">last event · </span>
          {latest.event_type_label}
        </div>
      )}
    </motion.div>
  );
}

function Metric({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-md border border-white/5 bg-white/5 py-1">
      <div className="mono font-semibold">{value}</div>
      <div className="section-tag !text-[8px]">{label}</div>
    </div>
  );
}
